<template>
  
    <el-container>
      <el-main>
        <h1>PDF 标注功能</h1>
        <h2>如何使用 PDF 标注功能?</h2>
        <h3>步骤 1. 首先要在设置页面设置 pdfjs 插件路径，目前已经简化设置方法</h3>
        <ol>
            <li>下载 pdfjs 插件,解压</li>
            <li>在 ios 系统下 , 在库中创建 <code>ios</code> 文件夹，然后将 pdfjs 文件夹放入</li>
            <li>在 andriod 系统下 , 创建 <code>andriod</code> 文件夹，然后将 pdfjs 文件夹放</li>
            <li>在电脑版 , 将 pdfjs 放入库的 <code>.obsidian </code> 文件夹, 注意 mac 系统，使用快捷键 <i>command+shift+. </i> 可以显示隐藏的文件夹</li>
            <li>Ctrl/cmd + p ,点击 <i>设置 pdfjs 插件路径</i>命令</li>
            <li>重启obsidian并在设置页面检查一下路径</li>
        </ol>
        <h4>下载 pdf js 插件</h4>
        <div>
        <p><a href="https://github.com/MarkMindCkm/obsidian-markmind/releases/download/1.4.5/pc.pdfjs.zip">电脑版 pdfjs </a><br>
        <a href="https://github.com/MarkMindCkm/obsidian-markmind/releases/download/1.3.6/mobile.pdfjs.zip">安卓版 pdfjs </a><br>
        <a href="https://github.com/MarkMindCkm/obsidian-markmind/releases/download/1.3.6/mobile.pdfjs.zip">ios版 pdfjs </a></p>
        </div>
        <h4>确保你的pdfjs下有以下文件夹</h4>
        <div>
          <img src="../assets/markmind/pdfjs.gif" width="800" alt="">
        </div>
        <h5>Ctrl/Cmd + p</h5>

        <div>
          <img src="../assets/markmind/pdfjs1.gif" width="800" alt="">
        </div>

        <h3>步骤 2. 使用 pdf 标注功能</h3>
        <p>在markdown 文件中添加 yaml</p>
               <pre>
        <code>
---

annotate-target: test/test.pdf
annotate-type: pdf

---
        </code>
       </pre>

       <p>可以在更多菜单中找到 <i>标注 pdf</i>命令 </p>

         <p><code>annotate-target</code> 支持的类型:</p>

         <ul>
            <li>库中的 pdf  , 如 <code>test/test.pdf</code>,这是个相对路径.</li>
            <li>其他硬盘中的 pdf, 如 <code>file://C:/test/test.pdf</code>,这是绝对路径.</li>
            <li>网络上的 pdf (需要保证可以访问), 如 <code> https://mozilla.github.io/pdf.js/legacy/web/compressed.tracemonkey-pldi-09.pdf</code>,这是个链接.</li>
         </ul>

         <div>
          <img src="../assets/markmind/pdfannotator.gif" width="800" alt="">
         </div>

        
        <h3>关于矩形截图保存的文件夹路径 </h3>
      <ul>
        <li>你可以在设置页面添加 保存矩形的截图文件夹( 一个相对路径，指向你库中的某个文件夹)</li>
        <li>或者你可以在yaml中添加</li>
      </ul>

       <div>
          <img src="../assets/markmind/pdfimg.gif" width="800" alt="">
         </div>

         

      <pre>

        <code>
---

annotate-target: test/test.pdf
annotate-type: pdf
annotate-image-target: assets/image

---
        </code>
      </pre>

      <h3>使用 pdf 标注的演示</h3>

        <div>
          <img src="../assets/markmind/pdf.gif" width="800" alt="">
         </div>

          <div>
          <img src="../assets/markmind/usepdfannotator.gif" width="800" alt="">
         </div>
           
         <h4>当你创建标注时，保存数据有两种方式</h4>
         <ul>
              <li>默认情况下，将会创建一个 <i> annos </i> 文件保存数据, 其本质是个 <i>json</i>文件 </li>
            
              <li>或者你可以在设置页面修改为 (保存标注数据的类型 ) <i>markdown</i> , 这种情况下，将会创建 <i>${pdf name}-annotate.md</i> 这种格式的md文件. 每个标注都会关联一个块，请不要手动修改</li>
         </ul>

          <div>
          <img src="../assets/markmind/types.gif" width="800" alt="">
         </div>
        

      <h3>快捷键</h3>

  <table>   
     <tr>
        <th>功能</th>
        <th>快捷键</th>
     </tr>

     <tr>
        <td>黄色高亮</td>
        <td>CTRL/CMD/ALT + Y</td>
     </tr>

     <tr>
        <td>绿色高亮</td>
        <td>CTRL/CMD/ALT + G</td>
     </tr>

     <tr>
        <td>红色高亮</td>
        <td>CTRL/CMD/ALT + R</td>
     </tr>
     <tr>
        <td>粉色高亮</td>
        <td>CTRL/CMD/ALT + P</td>
     </tr>

      <tr>
        <td>蓝色高亮</td>
        <td>CTRL/CMD/ALT + B</td>
     </tr>

  </table>
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'tablePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
